import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AuthRepository } from './repository/auth/auth.repository';
import { PersonRepository } from './repository/person/person.repository';
import { DriverRepository } from './repository/driver/driver.repository';
import { HomeRepository } from './repository/home/home.repository';
import { UserRepository } from './repository/user/user.repository';
import { VehicleRepository } from './repository/vehicle/vehicle.repository';
import { ReservaRepository } from './repository/reserva/reserva.repository';
import { ParametrosRepository } from './repository/parametros/parametros.repository';
import { ApiSecundariaRepository } from './repository/home/apiSecundaria.repository';
import { GetParametrosLocacaoRepository } from './repository/home/getParametrosLocacao.respository';
import { GetApiSecundariaRepository } from './repository/home/getApiSecundarias.repository';
import { GetConfiguracoesInternacionalizacaoRepository } from './repository/home/getConfiguracoesInternacionalizacao.repository';
import { GetTiposEnderecoRepository } from './repository/home/getTiposEndereco.repository';
import { GetPaisesRepository } from './repository/home/getPaises.repository';
import { GetMunicipiosRepository } from './repository/home/getMunicipios.repository';

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule],
  providers: [AuthRepository, UserRepository, DriverRepository, HomeRepository, VehicleRepository, PersonRepository, ReservaRepository, ParametrosRepository, ApiSecundariaRepository, GetParametrosLocacaoRepository, GetApiSecundariaRepository, GetConfiguracoesInternacionalizacaoRepository, GetTiposEnderecoRepository, GetPaisesRepository, GetMunicipiosRepository],
})
export class DataModule {}
